import * as images from "./images";

const NAME = "BLACKWAVE";

export const info = {
  id: "blackwave",
  name: NAME,
  secondName: "Analog Bass Synthesizer",
  image: images.overview,
  manualFile: "",
  extraFeatures: [
    {
      type: "blackwave-editor",
      routeSlug: "settings-editor",
      navLabel: "Settings\nEditor",
      usbDeviceName: NAME,
      safariDisabled: true,
      labels: {
        panelPlaceholder: "Interactive panel coming soon",
        sectionMidi: "MIDI",
        labelChannel: "RX channel",
        sectionDuo: "Duo mode",
        labelDuoRetrigger: "Envelope",
        duoLegato: "Legato",
        duoRetrigger: "Retrigger",
      },
    },
  ],
};

export const overview = [
  {
    image: images.overview,
    introDescription: "<strong>BLACKWAVE</strong> description.",
    sectionsIntro: "section intro:",
    subsections: [
      {
        title: "SUBSECTION TITLE",
        text: "subsection description",
      },
    ],
    conclusion: "conclusion",
  },
  {
    image: images.section01,
    heading: "HEADING",
    paragraphs: ["paragraph"],
  },
];

export const sections = [
  {
    title: "SECTION 1",
    image: images.section01,
    description: "Section 1 description",
  },
];

export const photos = {
  desktop: [images.desktop01],
  mobile: [images.mobile01],
};

export const videos = [];

export const features = ["Feature 1"];

export const specifications = ["Dimensions: TBD", "Weight: TBD", "Class compliant USB MIDI"];
